<template>
  <div class="logo-tile">
    <img
      src="../assets/MB_Monogram_White_RGB.png"
      alt="Matt Barnes logo"
    >
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.logo-tile {
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  height: 180px;
  width: 180px;
  margin: 2rem;
  background: black;
  border-radius: 4px;
}
</style>
